import React from "react";

import AutomatedMessageText from "../../AutomatedMessageText";

const AutomatedMessageDeclinedEnquiry = ({ children }) => {
  return (
    <AutomatedMessageText tagTitle="Enquiry Closed">
      {children}
    </AutomatedMessageText>
  );
};

export default AutomatedMessageDeclinedEnquiry;
